exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);

// module
exports.push([module.id, ".skanetrafiken-search .autocomplete {\n  margin-top: 2.5rem; }\n\n.skanetrafiken-search .autocomplete-trigger {\n  display: flex;\n  align-items: center;\n  border: 1px solid #eee;\n  border-radius: 4px;\n  padding: 1rem; }\n  .skanetrafiken-search .autocomplete-trigger .anticon {\n    margin-right: 1rem;\n    font-size: 1.15em;\n    color: #231f20; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/components/PickSkanetrafiken/SkanetrafikenSearch/SkanetrafikenSearch.scss
// module id = 1604
// module chunks = 0